import { render, staticRenderFns } from "./FS.vue?vue&type=template&id=1836a342&scoped=true&"
import script from "./FS.vue?vue&type=script&lang=js&"
export * from "./FS.vue?vue&type=script&lang=js&"
import style0 from "./FS.vue?vue&type=style&index=0&id=1836a342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836a342",
  null
  
)

export default component.exports